import standardAction from '../../../utilities/standard-action';
import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';

export default function hideReturnConfirmation(): RootActionTypes {
  return standardAction(ActionTypes.HIDE_RETURN_CONFIRMATION);
}
